import { fetchAuthSession, fetchUserAttributes, getAuthKeyValues, getRefreshToken } from './cognito/cognito.helper.js';
import './auth.store.js';
import { getAuthConfig } from './config.js';
import { globalSignOutSideEffect } from './actions/auth-signout.actions.js';
import { AUTH_PROVIDER_NAMES } from './auth.types.js';

const getAuthWebViewConfig = async ()=>{
    try {
        const authSession = await fetchAuthSession();
        if (!authSession) {
            return null;
        }
        const userAttributes = await fetchUserAttributes();
        const allAuthKeyValues = getAuthKeyValues();
        // TODO: Try to remove this
        const refreshToken = await getRefreshToken();
        return {
            refreshToken,
            userAttributes,
            allAuthKeyValues
        };
    } catch (error) {
        if (error?.name === 'NotAuthorizedException') {
            await globalSignOutSideEffect();
            return null;
        }
        const config = getAuthConfig();
        if (config.onError) {
            config.onError(error, {
                context: 'getAuthWebViewConfig',
                message: 'Error in getAuthWebViewConfig'
            });
        } else {
            console.error('getAuthWebViewConfig error:', error);
            throw error;
        }
        return null;
    }
};
const isFederatedUser = async ()=>{
    try {
        const userAttributes = await fetchUserAttributes();
        const parsedIdentities = JSON.parse(userAttributes?.identities ?? '[]');
        return Array.isArray(parsedIdentities) && parsedIdentities?.some((i)=>(i?.providerName === AUTH_PROVIDER_NAMES.GOOGLE || i?.providerName === AUTH_PROVIDER_NAMES.APPLE) && !!i?.primary);
    } catch (error) {
        const config = getAuthConfig();
        if (config.onError) {
            config.onError(error, {
                context: 'isFederatedUser',
                message: 'Error in isFederatedUser'
            });
        } else {
            console.error('isFederatedUser error:', error);
            throw error;
        }
        return false;
    }
};

export { getAuthWebViewConfig, isFederatedUser };
//# sourceMappingURL=getAuthWebViewConfig.helpers.js.map
